import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import JsonData from "./data/data.json";
// import SmoothScroll from "smooth-scroll";
import LoginComponent from "./components/LoginComponent";
import "./Login.css";

// export const scroll = new SmoothScroll('a[href*="#"]', {
//   speed: 1000,
//   speedAsDuration: true,
// });

const Login = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <LoginComponent data={landingPageData.Header} />

    </div>
  );
};

export default Login;
